import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services';
import { BasketService } from 'src/app/_services/basket.service';

@Component({
  selector: 'app-axa-bar',
  templateUrl: './axa-bar.component.html',
  styleUrls: ['./axa-bar.component.css']
})
export class AxaBarComponent implements OnInit {

  public show : boolean;
  public price : number;
  public stringPrice : string = "0 €"
  constructor(
    private auth : AuthenticationService,
    private basketSrv: BasketService
  ) {

   }

  ngOnInit() {
    this.auth.currentUser.subscribe(user =>{
      if (user) {
        if (user.payload.nameid != "0") {
          this.getPriceAXA(user.id_user);
        }
      }
      this.show = this.auth.isAxA;
    })

  }

  getPriceAXA(id : string){
    this.basketSrv.getPriceHeaderAXA(id).subscribe({
      next: (res : number) => {
        this.price = res
        this.stringPrice = (this.price / 100) + "€"
      }

    })

  }


}
